import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiURI } from '../config.js';
import Bugsnag from '@bugsnag/expo';
import { PivotLogging } from './cbcLoggingSlice.js';

/** STATE OBJECT */
const initialState = {
  loading_msg: 'idle',
  fetchActivitiesResultsMsg: '',
  activityChoices: [],
};

export const fetchAllCurrentActivities = createAsyncThunk(
  'cbcActivitiesSlice/fetchAllCurrentActivities',
  async (_, { rejectWithValue, dispatch }) => {
    Bugsnag.leaveBreadcrumb('Action fetchAllCurrentActivities useDispatched');
    dispatch(PivotLogging({ moduleName: 'cbcActivitiesSlice', consoleLog: 'fetchAllCurrentActivities useDispatched' }));

    const response = await fetch(`${apiURI}/fetch-all-current-activities.php`, {
      method: 'GET',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      },
    });

    const results = await response.json();
    dispatch(PivotLogging({ moduleName: 'cbcActivitiesSlice', consoleLog: `fetchAllCurrentActivities response: ${JSON.stringify(response)}` }));
    dispatch(PivotLogging({ moduleName: 'cbcActivitiesSlice', consoleLog: `fetchAllCurrentActivities results: ${JSON.stringify(results)}` }));

    if (response.ok) {
      if (!results.success) {
        return rejectWithValue(results.message);
      }
      return results;
    } else {
      Bugsnag.notify(`Api Error, fetch-all-current-activities: ${response.text()}`);
      return rejectWithValue(response.text());
    }
  }
);

/** DEFINE REDUCERS */
export const cbcActivitiesSlice = createSlice({
  name: 'cbcActivitiesSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCurrentActivities.pending, (state) => {
        state.loading_msg = 'pending';
        state.fetchActivitiesResultsMsg = 'Fetching activities';
      })
      .addCase(fetchAllCurrentActivities.fulfilled, (state, { payload }) => {
        state.loading_msg = 'idle';
        state.fetchActivitiesResultsMsg = 'success';
        state.activityChoices = payload.activityList;
      })
      .addCase(fetchAllCurrentActivities.rejected, (state, { payload }) => {
        state.loading_msg = 'failed';
        state.fetchActivitiesResultsMsg = payload;
      });
  },
});

// Extract the reducer from the slice
const { reducer } = cbcActivitiesSlice;

// Export the reducer
export default reducer;
